import React, { useCallback } from 'react'

import { useReactFlow } from '@xyflow/react'

import Box from 'components_new/atoms/Box'

import Node from 'components_new/molecules/Node'

import NodeType from 'types/transformation/enums/NodeType'
import { InputNode, Node as TNode } from 'types/transformation/types/nodes'
import { useSourceSchemas } from 'redux/hooks/SimTables'

import SourceTableSelect from './SourceTableSelect'
import { useIsInvalid } from './hooks'

interface InputNodeProps {
  id: string
  data: InputNode
  selected: boolean
}

const Input = (props: InputNodeProps) => {
  const { data, selected } = props

  const { setNodes } = useReactFlow<TNode>()
  const [, activeSources] = useSourceSchemas()
  const isInvalid = useIsInvalid(data)

  const handleSelected = useCallback(
    (sourceTableId: string) => {
      setNodes((existingNodes) =>
        existingNodes.map((node) =>
          node.id === data.id
            ? {
                ...node,
                data: {
                  ...node.data,
                  source_table_id: sourceTableId
                }
              }
            : node
        )
      )
    },
    [setNodes]
  )

  return (
    <Node
      error={isInvalid}
      icon="LoginOutlined"
      inputType={null}
      title={'Input'}
      selected={selected}
      nodeNumber={data.index}
      type={NodeType.INPUT}
    >
      <Box sx={{ width: '272px' }}>
        <SourceTableSelect
          onChange={handleSelected}
          sources={activeSources}
          value={data.source_table_id}
        />
      </Box>
    </Node>
  )
}

export default Input
